<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconLock_16"
    viewBox="0 0 16 16"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        fill-rule="evenodd"
        d="M4.846 4.538v-.461a3.078 3.078 0 0 1 6.154 0v2.308h1.539c.34 0 .615.275.615.615v7.385c0 .34-.276.615-.615.615H3.615A.615.615 0 0 1 3 14.385V7c0-.34.276-.615.615-.615h1.231V4.538M9.77 6.385V4.077c0-1.052-.794-1.908-1.846-1.908s-1.846.856-1.846 1.908v2.308z"
        clip-rule="evenodd"
    />
</svg>
